import * as React from "react";
import Box from "@mui/material/Box";
import { styled, ThemeProvider } from "@mui/material/styles";
import { devcenterTheme } from "../_global-mui-theme";
import { Link, List, Typography } from "@mui/material";
import { Trans } from "react-i18next";

const HANCOM_URL = "https://www.hancom.com";
const AGREEMENT_URL = "https://accounts.hancom.com/policy/terms/current";
const TREAT_INFO_AGREEMENT_URL =
  "https://accounts.hancom.com/policy/privacy/current/ko";

const HDCFooter = styled(Box)(({ theme }) => ({
  color: "#fff",
  fontSize: "0.875rem",
  fontWeight: "400",
  background: "#000",
  letterSpacing: "0.33px",

  ".MuiList-root": {
    paddingBottom: "0",
  },

  li: {
    display: "inline-block",
    paddingRight: "12px",
    fontSize: "0.875rem",
    color: "rgba(255, 255, 255, 0.6)",
  },

  [theme.breakpoints.down("md")]: {
    padding: "32px 24px",
  },

  [theme.breakpoints.up("md")]: {
    padding: "32px",
  },
}));

const HDCLink = styled(Box)(() => ({
  a: {
    color: "inherit",

    "&:first-of-type": {
      position: "relative",
      paddingRight: "17px",
      marginRight: "16px",

      "&::after": {
        content: '" "',
        position: "absolute",
        width: "1px",
        height: "12px",
        right: "0",
        top: "2px",
        background: "#fff",
      },
    },
  },
}));

function FooterComponent() {
  return (
    <ThemeProvider theme={devcenterTheme}>
      <HDCFooter sx={{ displayPrint: "none", marginTop: "auto" }}>
        <HDCLink>
          <Link
            underline="none"
            href={AGREEMENT_URL}
            target="_blank"
            rel="noreferrer"
          >
            <Trans i18nKey="footer.terms" ns="translation" />
          </Link>
          <Link
            sx={{ fontWeight: "bold" }}
            underline="none"
            href={TREAT_INFO_AGREEMENT_URL}
            target="_blank"
            rel="noreferrer"
          >
            <Trans i18nKey="footer.privacyPolicy" ns="translation" />
          </Link>
        </HDCLink>
        <List component="ul">
          <Typography component="li">
            <Trans i18nKey="footer.company.name" ns="translation" />
          </Typography>
          <Typography component="li">
            <Trans i18nKey="footer.company.ceo" ns="translation" />
          </Typography>
          <Typography component="li">
            <Trans
              i18nKey="footer.company.registrationNumber"
              ns="translation"
            />
          </Typography>
          <Typography component="li">
            <Trans i18nKey="footer.company.address" ns="translation" />
          </Typography>
          <Typography component="li">
            <Trans i18nKey="footer.copyright.forePart" ns="translation" />
            <Link
              sx={{ px: "3px", color: "inherit" }}
              underline="none"
              href={HANCOM_URL}
              target="_blank"
              rel="noreferrer"
            >
              <Trans i18nKey="footer.copyright.linkPart" ns="translation" />
            </Link>
            <Trans i18nKey="footer.copyright.afterPart" ns="translation" />
          </Typography>
        </List>
      </HDCFooter>
    </ThemeProvider>
  );
}

export default FooterComponent;
